/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Totp_Not_EnrolledInputs */



/**
* | output |
* | --- |
* | "TOTP is not set up for this account." |
*
* @param {Auth_Totp_Not_EnrolledInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_totp_not_enrolled = /** @type {((inputs?: Auth_Totp_Not_EnrolledInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Totp_Not_EnrolledInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("TOTP ist für dieses Konto nicht eingerichtet.")
	return /** @type {LocalizedString} */ ("TOTP is not set up for this account.")
});